import { render, staticRenderFns } from "./Modify.vue?vue&type=template&id=2dc2ff76&scoped=true&"
import script from "./Modify.vue?vue&type=script&lang=js&"
export * from "./Modify.vue?vue&type=script&lang=js&"
import style0 from "./Modify.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Modify.vue?vue&type=style&index=1&id=2dc2ff76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc2ff76",
  null
  
)

export default component.exports